<template>
  <div>
    <v-dialog v-model="dialog_open" max-width="700" persistent>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title class="py-0">
            <v-col cols="10" sm="11">
              <span
                class="ml-3 font-weight-bold "
                style="font-size: 22px;  font-family: 'Sarabun', sans-serif;"
              >
                ใบรับรองแพทย์ การตรวจสุขภาพคนต่างด้าว/แรงงานต่างด้าว
              </span>
            </v-col>
            <v-col cols="2" sm="1">
              <v-btn icon @click="closeDialog()" style="text-align:right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-card-title>
          <v-card-text class="py-0">
            <!-- <v-form> -->
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    วันที่รับการตรวจ <span style="color: red;">*</span>
                    </span>
                    <v-menu
                      ref="menu"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                      :return-value.sync="health_check_date"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date_format"
                          persistent-hint
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          color="#00A99D"
                          outlined
                          dense
                          class="mt-1"
                          hide-details=""
                          :disabled="isApprove"
                          :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="payload.health_check_date"
                        no-title
                        :max="today"
                        color="#00A99D"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="#F5222D"
                          @click="menu2 = false"
                          outlined
                        >
                          ยกเลิก
                        </v-btn>
                        <v-btn
                          solo
                          color="#00A99D"
                          style="color: white;"
                          @click="$refs.menu.save(saveDate(payload.health_check_date))"
                        >
                          ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            <!-- </v-form> -->
          </v-card-text>
          <v-card-title class="py-0">
            <v-col cols="12" class="pb-0">
              <span
                style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
              >
                1. รายละเอียดประวัติส่วนตัวของผู้รับการตรวจสุขภาพ
              </span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-title>
          <v-card-text class="py-0">
            <!-- <v-form> -->
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                      1. ชื่อ-นามสกุล
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_name"
                      placeholder="ชื่อผู้ป่วย"
                      hide-details
                      outlined
                      dense
                      disabled
                      class="mt-1"
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                      VN
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_vn"
                      placeholder="VN"
                      hide-details
                      outlined
                      dense
                      disabled
                      class="mt-1"
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                      เลขประจำตัวประชาชน
                    </span>
                    <v-text-field
                      v-model="show_patient_cid"
                      placeholder="เลขประจำตัวประชาชน"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      disabled
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                    เลขที่ Passport
                    </span>
                    <v-text-field
                      v-model="show_patient_passport"
                      placeholder="เลขที่ Passport"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      disabled
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    วัน/เดือน/ปี เกิด
                    </span>
                    <v-text-field
                      v-model="patient_birth"
                      placeholder="เลขประจำตัวประชาชน"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      disabled
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    เมืองเกิด
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_ctiy_of_birth"
                      placeholder="เมืองเกิด"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="status_patient_ctiy_of_birth"
                      :style="status_patient_ctiy_of_birth ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    สัญชาติ
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_nationality"
                      placeholder="สัญชาติ"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="status_patient_nationality"
                      :style="status_patient_nationality ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    อาชีพ
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_job"
                      placeholder="อาชีพ"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="status_patient_job != ''"
                      :style="status_patient_job ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                      2. ที่อยู่ปัจจุบัน
                    </span>
                    <v-textarea
                      v-model="display_address"
                      placeholder="สถานที่อยู่(ที่สามารถติดต่อได้)"
                      color="#00A99D"
                      auto-grow
                      hide-details
                      rows="4"
                      row-height="20"
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="status_display_address"
                      :style="status_display_address ? 'background-color: #E8E9E9;' : ''"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    เบอร์โทรศัพท์
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_phone"
                      placeholder="เบอร์โทรศัพท์"
                      color="#00A99D"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      disabled
                      style="background-color: #E8E9E9;"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            <!-- </v-form> -->
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text>

          <v-card-title class="py-0">
            <v-col cols="12" class="pb-0">
              <span
                style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
              >
              2.	ข้อมูลนายจ้าง/สถานประกอบการ
              </span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-title>
          <v-card-text class="py-0">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                      ชื่อ-นามสกุล(นายจ้าง)/สถานประกอบการ
                    </span>
                    <v-text-field
                      v-model="payload.employer.employer_name"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      :disabled ="status_employer_name != ''"
                      :style="status_employer_name ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                    เบอร์โทรศัพท์
                    </span>
                    <v-text-field
                      v-model="payload.employer.employer_phone"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      :disabled ="status_employer_phone != ''"
                      :style="status_employer_phone ? 'background-color: #E8E9E9;' : ''"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                      อยู่บ้านเลขที่
                    </span>
                    <v-textarea
                      v-model="payload.employer.employer_address"
                      placeholder="สถานที่อยู่(ที่สามารถติดต่อได้)"
                      color="#00A99D"
                      auto-grow
                      hide-details
                      rows="4"
                      row-height="20"
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="status_employer_address != ''"
                      :style="status_employer_address ? 'background-color: #E8E9E9;' : ''"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text>
          <v-card-title class="py-0">
            <v-col cols="12" class="pb-0">
              <span
                style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
              >
              3. ข้อมูลแพทย์ผู้ตรวจ
              </span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-title>
          <v-card-text class="py-0">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                      แพทย์ผู้ตรวจ <span style="color: red;">*</span>
                    </span>
                    <v-combobox
                      attach
                      v-model="select_doc"
                      placeholder="ชื่อแพทย์"
                      :item="searchDoc"
                      outlined
                      dense
                      hide-details
                      :items="searchDoc"
                      @input="searchDoctor"
                      item-text="name_th"
                      return-object
                      class="mt-1"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                      :disabled="isApprove"
                      :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                      color="#00A99D"
                    >
                      <template v-slot:append>
                        <img src="../../assets/icon/medcert/search.svg" alt="search">
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="6">
                    <span
                      style="font-size: 16px;"
                    >
                    ใบอนุญาตประกอบโรคศิลปะ เลขที่
                    </span>
                    <v-text-field
                      v-model="payload.doctor.doctor_license"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      :disabled ="payload.doctor.doctor_license != ''"
                      :style="payload.doctor.doctor_license ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    สถานพยาบาลชื่อ
                    </span>
                    <v-text-field
                      v-model="payload.biz.biz_name"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      :disabled ="payload.biz.biz_name != ''"
                      :style="payload.biz.biz_name ? 'background-color: #E8E9E9;' : ''"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    ที่อยู่
                    </span>
                    <v-textarea
                      v-model="payload.biz.biz_address"
                      placeholder="สถานที่อยู่(ที่สามารถติดต่อได้)"
                      color="#00A99D"
                      auto-grow
                      hide-details
                      rows="4"
                      row-height="20"
                      outlined
                      dense
                      class="mt-1"
                      :disabled ="payload.biz.biz_address != ''"
                      :style="payload.biz.biz_address ? 'background-color: #E8E9E9;' : ''"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text>
          <v-card-text class="py-0">
              <v-container>
                <v-row>
                  <v-col cols="2">
                    <span
                      style="font-size: 16px;"
                    >
                      ความสูง
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_height"
                      placeholder="(ซม.)"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      @keypress="validateNumber"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <span
                      style="font-size: 16px;"
                    >
                      น้ำหนัก
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_weight"
                      placeholder="(กก.)"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      @keypress="validateNumber"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <span
                      style="font-size: 16px;"
                    >
                      สีผิว
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_skin_color"
                      placeholder="สีผิว"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    ความดันโลหิต
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_blood_pressure"
                      placeholder="(มม.ปรอท)"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <span
                      style="font-size: 16px;"
                    >
                    ชีพจร
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_pulse"
                      placeholder="(ครั้ง/นาที)"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                      @keypress="validateNumber"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    สภาพร่างกาย จิตใจทั่วไป
                    </span>
                    <v-text-field
                      v-model="payload.patient.patient_physical_condition"
                      placeholder="สภาพร่างกาย"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจวัณโรค <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-12" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_tuberculos"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ผิดปกติ/รักษา"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ระยะอันตราย"
                          :value="'3'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex justify-space-between" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจโรคเรื้อน <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_leprosy"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ผิดปกติ/รักษา"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ระยะติดต่อ/อาจเป็นที่รังเกียจ"
                          :value="'3'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจโรคเท้าช้าง <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-5" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_elephantiasis"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ผิดปกติ/รักษา"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="อาจเป็นที่รังเกียจ"
                          :value="'3'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจโรคซิฟิลิส <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-7" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_syphilis"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ผิดปกติ/รักษา"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ระยะที่ 3"
                          :value="'3'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจสารเสพติด <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-6" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_narcotic"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="พบสารเสพติด"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ให้ตรวจยืนยันการรักษา"
                          :value="'3'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจอาการของโรคพิษสุราเรื้อรัง <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-10" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_alcoholism"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ปกติ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="ปรากฏอาการ"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      ผลการตรวจหาเชื้อไวรัสโคโรนา 2019 <span style="color: red;">*</span>
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-14" style="align-items: baseline;">
                      <v-radio-group
                        v-model="payload.result_corona"
                        row
                        class="mt-0 pt-0"
                      >
                        <v-radio
                          label="ไม่พบเชื้อ"
                          :value="'1'"
                        color="#00A99D"
                        ></v-radio>
                        <v-radio
                          label="พบเชื้อ"
                          :value="'2'"
                        color="#00A99D"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                    ผลการตรวจอื่นๆ (ถ้ามี)
                    </span>
                    <v-text-field
                      v-model="payload.result_other"
                      placeholder="ผลการตรวจอื่นๆ"
                      hide-details
                      outlined
                      dense
                      class="mt-1"
                      color="#00A99D"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text>
          <v-card-title class="py-0">
            <v-col cols="12" class="pb-0">
              <span
                style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
              >
                สรุปผลการตรวจ
              </span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-title>
          <v-card-text class="py-0">
              <v-container>
                <v-row>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      1.
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-3" style="align-items: baseline;">
                      <v-checkbox
                        v-model="payload.result_body"
                        value="1"
                        hide-details
                        class="shrink mt-0 "
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      สุขภาพสมบูรณ์ดี
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="d-flex py-0 ms-6" style="align-items: baseline;">
                      <v-checkbox
                        v-model="payload.result_body"
                        value="2"
                        hide-details
                        class="shrink mt-0 "
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      ผ่านการตรวจสุขภาพ แต่ต้องให้รักษา
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      2.
                      </span>
                    </div>
                    <div class="d-flex py-0 ms-3" style="align-items: baseline;">
                      <v-checkbox
                        v-model="payload.result_disease"
                        value="1"
                        hide-details
                        class="shrink mt-0 "
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      วัณโรค
                      </span>
                      <v-checkbox
                        v-model="payload.result_disease"
                        value="2"
                        hide-details
                        class="shrink mt-0 ms-3"
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      โรคเรื้อน
                      </span>
                      <v-checkbox
                        v-model="payload.result_disease"
                        value="3"
                        hide-details
                        class="shrink mt-0 ms-3"
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      โรคเท้าช้าง
                      </span>
                      <v-checkbox
                        v-model="payload.result_disease"
                        value="4"
                        hide-details
                        class="shrink mt-0 ms-3"
                        color="#00A99D"
                      ></v-checkbox>
                      <span
                        class="mt-1"
                        style="font-size: 16px;"
                      >
                      โรคซิฟิลิส
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0 d-flex" style="align-items: baseline;">
                    <div class="py-0">
                      <span
                        style="font-size: 16px;"
                      >
                      3.	ไม่ผ่านการตรวจสุขภาพเนื่องจาก
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <div class="d-flex py-0 ms-6" style="align-items: baseline;">
                    <span
                      style="font-size: 16px;"
                    >
                      3.1
                      </span>
                    <v-checkbox
                      v-model="payload.result_failed_body"
                      value="1"
                      hide-details
                      class="shrink mt-0 "
                      color="#00A99D"
                    ></v-checkbox>
                    <span
                      class="mt-1"
                      style="font-size: 16px;"
                    >
                    ร่างกายทุพพลภาพจนไม่สามารถประกอบการหาเลี้ยงชีพได้/จิตฟั่นเฟือน ไม่สมประกอบ
                    </span>
                  </div>
                </v-row>
                <v-row>
                  <div class="d-flex py-0 ms-6" style="align-items: baseline;">
                    <span
                      style="font-size: 16px;"
                    >
                      3.2
                      </span>
                    <v-checkbox
                      v-model="payload.result_failed_body"
                      value="2"
                      hide-details
                      class="shrink mt-0 "
                      color="#00A99D"
                    ></v-checkbox>
                    <span
                      class="mt-1"
                      style="font-size: 16px;"
                    >
                    เป็นโรคไม่อนุญาตให้ทำงานและไม่ให้ประกันสังคม (ตามประกาศกระทรวงสาธารณสุข)
                    </span>
                  </div>
                </v-row>
              </v-container>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text>
          <!-- <v-card-title class="py-0">
            <v-col cols="12" class="pb-0">
              <span
                style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
              >
                ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง
              </span>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-title>

          <v-card-text class="py-0">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span
                      style="font-size: 16px;"
                    >
                      ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง <span style="color: red;">*</span>
                    </span>
                    <v-combobox
                      attach
                      placeholder="ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง"
                      v-model="select_doc"
                      outlined
                      dense
                      hide-details
                      :items="searchDoc"
                      @input="searchDoctor"
                      item-text="name_th"
                      return-object
                      class="mt-1"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                      :disabled="isApprove"
                      :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                      color="#00A99D"
                    >
                      <template v-slot:append>
                        <img src="../../assets/icon/medcert/search.svg" alt="search">
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-card-text> -->

          <v-card-text class="py-0">
            <v-row align="center" class="px-8 mt-5">
              <v-col cols="6" align="end">
                <v-btn
                  @click="closeDialog()"
                  style="width: 100%;"
                  outlined
                  color="#00a99d"
                  dark
                  class="card-medium-cancel"
                >
                  <span style="color: #00a99d;" class="font-14">ยกเลิก</span>
                </v-btn>
              </v-col>
              <v-col cols="6" align="start">
                <v-btn
                  class="card-medium"
                  style="width: 100%;"
                  depressed
                  color="#00a99d"
                  :loading="loading_btn"
                  :disabled="!valid || disabled_btn"
                  @click="btn_name == 'อนุมัติเอกสาร' ? approveDoc() : requestDoc()"
                >
                  <span style="color: #FFFFFF;" class="font-14"
                    >{{ btn_name }}</span
                  >
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <ApproveDoc ref="approveDoc"/>
  </div>
</template>

<script>
import moment from 'moment'

import ApproveDoc from '@/components/dialog/ApproveDialog.vue'
import { EventBus } from "@/EventBus"
import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    ApproveDoc
  },
  data: () => ({
    loading_btn: false,
    dialog_open: false,
    valid: true,

    payload: {
      //biz
      biz: {
        biz_address: "",
        biz_id: "",
        biz_name: "",
      },
      //doctor
      doctor: {
        biz_id: "",
        doctor_license: "",
        doctor_name: "",
        one_id: ""
      },
      //patient
      patient: {
        one_id:"",
        patient_name: "",
        patient_address:"",
        patient_birth:"",
        patient_vn:"",
        patient_ctiy_of_birth:"",
        patient_nationality:"",
        patient_job:"",
        patient_phone:"",
        patient_height:"",
        patient_weight:"",
        patient_skin_color:"",
        patient_blood_pressure:"",
        patient_pulse:"",
        patient_physical_condition:"",
        patient_id_card_number:"",
        patient_passport:""
      },
      employer: {
        employer_name: "",
        employer_address: "",
        employer_phone: ""
      }
    },
    show_patient_cid: "",
    show_patient_passport:"",
    select_doc: {
      name_th: "เลือกแพทย์"
    },

    display_address: "",

    //ข้อมูลการตรวจ
    health_check_date: "",
    request_date: "",
    enabled_other: false,
    other: "",
    summary: "",

    doc_code: "",
    doc_name: "",

    _id: "",

    menu2: "",
    today: moment().format("YYYY-MM-DD"),
    btn_name: "",
    date_format: "วัน/เดือน/ปี",
    searchDoc: [],
    isApprove: false,
    cid: "",
    patient_birth:"",
    rules: {
      // required: v => !!v || 'กรุณากรอกข้อมูล',
      mobile: [
        (v) => !!v || "กรุณากรอกเบอร์โทรศัพท์",
        (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
      ],
    },
    status_patient_ctiy_of_birth:false,
    status_patient_nationality:false,
    status_patient_job:false,
    status_display_address:false,
    status_employer_name:false,
    status_employer_phone:false,
    status_employer_address:false,
    mode: "",
    err_msg:"",
    patient_id:""
  }),
  watch: {
    // select_doc (val) {
    //   if (val) {
    //     this.payload.doctor_license = val.doctor_license
    //     this.payload.name_doctor_th = val.doctor_name
    //     this.payload.doctor_one_id = val.one_id
    //   }
    //   console.log(this.payload);
    // },
    dialog_open (val) {
      if (!val) {
        this.$refs.form.resetValidation()
      }
    },
    enabled_other (val) {
      if (!val) {
        this.payload.other = ""
      }
    }
  },
  async mounted () {

  },
  computed: {
    disabled_btn () {
      if (
        this.payload.check_congenital_disease && !this.payload.congenital_disease ||
        this.payload.check_emergency_urgency && !this.payload.emergency_urgency ||
        this.payload.check_admit && !this.payload.admit ||
        this.payload.check_general_physical && !this.payload.general_physical ||
        this.select_doc.name_th === 'เลือกแพทย์'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async open (input) {
      // console.log("payload", input.item);
      // console.log("input", input)
      this.select_doc = {
        name_th: "เลือกแพทย์"
      }
      this.patient_id = input.patient_id
      this.payload = input.item
      this.request_date = input.item.request_date
      this.health_check_date = input.item.health_check_date
      if (input.item.other) {
        this.enabled_other = true
      }
      this.mode = input.mode
      this.btn_name = "ออกเอกสาร"

      let address = ""
      if (Array.isArray(this.payload.patient.patient_address)){
        if (this.payload.patient.patient_address.length > 0){
          const index_address = this.payload.patient.patient_address.length - 1
          for (const key of Object.entries(this.payload.patient.patient_address[index_address])) {
            if (key[1] && key[1] != 'null') {
              if (key[0] == "houseNo") {
                address = address + "บ้านเลขที่ " + key[1] + " "
              } else if (key[0] == "moo") {
                address = address + "หมู่ที่ " + key[1] + " "
              } else if (key[0] == "soi") {
                address = address + "ซอย " + key[1] + " "
              } else if (key[0] == "amphur") {
                address = address + "อำเภอ/เขต " + key[1] + " "
              } else if (key[0] == "tambon") {
                address = address + "ตำบล/แขวง " + key[1] + " "
              } else if (key[0] == "province") {
                address = address + "จังหวัด " + key[1] + " "
              } else if (key[0] == "zipcode") {
                address = address + "รหัสไปรษณีย์ " + key[1] + " "
              }
            }
          }
          this.display_address = address
        }
      } else {
        this.display_address = this.payload.patient.patient_address
      }
      if (this.display_address){
        this.status_display_address = true
      }
      if (this.payload.patient.patient_id_card_number){
        this.show_patient_cid = functioncryto.decrypt(this.payload.patient.patient_id_card_number)
      } else {
        this.show_patient_passport = functioncryto.decrypt(this.payload.patient.patient_passport)
      }
      if (this.payload.patient.patient_birth){
        this.patient_birth =  moment(this.payload.patient.patient_birth).add(543, "year").locale("th").format("DD/MM/YYYY")
      }
      this.date_format = moment(input.item.health_check_date).add(543, "year").locale("th").format("DD MMMM YYYY")

      this.doc_code = input.doc_code
      this.doc_name = input.doc_name
      if (this.payload.patient.patient_nationality){
        this.status_patient_nationality = true
      }
      if (this.payload.patient.patient_ctiy_of_birth){
        this.status_patient_ctiy_of_birth = true
      }
      if (this.payload.patient.patient_job){
        this.status_patient_job = true
      }
      if (this.payload.employer.employer_name){
        this.status_employer_name = true
      }
      if (this.payload.employer.employer_phone){
        this.status_employer_phone = true
      }
      if (this.payload.employer.employer_address){
        this.status_employer_address = true
      }
      if (input.mode == "approve") {
        this._id = input._id
        this.isApprove = true
        this.btn_name = "อนุมัติเอกสาร"
      }
      await this.getStaff()
      // this.$refs.form.resetValidation()
      this.dialog_open = true
      setTimeout(() => {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
      }, 100)
    },
    closeDialog () {
      this.dialog_open = false
      this.status_display_address = false
      this.status_employer_phone = false
      this.status_patient_nationality = false
      this.status_patient_ctiy_of_birth = false
      this.status_patient_job = false
      this.status_employer_name = false
      this.status_employer_address = false
      this.show_patient_cid = ""
      this.show_patient_passport = ""
    },
    formatDate (date) {
      return moment(date).add(543, "year").locale("th").format("DD MMMM YYYY")
    },
    async approveDoc () {
      // console.log("approve", this.payload)
      // console.log("id", this._id)
      try {
        let params = new URLSearchParams()
        params.append("id", this._id)/
        params.append("doc_type", this.doc_code)
        this.payload.patient.patient_address = this.display_address
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/updateTransaction?${params}`,
        // await this.axios.post(`http://localhost:5000/v1/updateTransaction?${params}`,
          {
            payload: this.payload
          }
        ).then((res) => {
          // console.log("=>", res)
          if (res.data.result === "success") {
            EventBus.$emit('getData')
            this.createPdf()
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async createPdf () {
      // console.log(this.select_doc)
      this.loading_btn = true
      this.payload.patient.patient_address = this.display_address
      // console.log(this.request_date);
      // console.log(this.health_check_date);
      this.payload.patient.patient_id_card_number = functioncryto.decrypt(this.payload.patient.patient_id_card_number)
      await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/create-med-cert`,
      // await this.axios.post(`http://localhost:5000/v1/sign/create-med-cert`,
        {
          payload: this.payload,
          sign_position: 2.2,
          doc_code: this.doc_code,
          doc_name: this.doc_name,
          pageToSign: 1,
          biz_id: sessionStorage.biz_id,
          request_date: this.request_date,
          health_check_date: this.health_check_date,
          file_id: "",
          status: "request"
          // payload: {
          // },
        }
      ).then((res) => {
        // console.log(res)
        if (res.data.result == "success") {
          let item = {
            id: this._id,
            doc_code: this.doc_code,
            pdf_data: res.data.data,
            doctor_name: this.payload.name_doctor_th,
            cid: functioncryto.encrypt(this.payload.patient.patient_id_card_number),
            payload_success:res.data.payload
          }

          if (this.doc_code == "FORMFOREINGWORKERS") {
            this.$refs.approveDoc.open(item)
          }
        }

        this.loading_btn = false
        this.closeDialog()
      })
      .catch((err) => {
        this.loading_btn = false
        console.log('err:', err.message)
      })
    },
    saveDate (date) {
      this.date_format = moment(date).add(543, "year").locale("th").format("DD MMMM YYYY")
      this.payload.health_check_date = moment(date).locale("th").format("DD-MM-YYYY")
      this.payload.day = moment(date).locale("th").format("DD")
      this.payload.month = moment(date).locale("th").format("MM")
      this.payload.year = moment(date).add(543, "year").locale("th").format("YYYY")
      // console.log(this.payload);
      return moment(date).locale("th").format("YYYY-MM-DD")
    },
    async requestDoc () {
      // console.log(this.payload);
      this.$swal.fire({
        title: `<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>หากคุณต้องการขอ ${this.doc_name} ของ "${this.payload.patient.patient_name}"<br/>กรุณากดยืนยันเพื่อดำเนินการต่อ</span>`,
        showCancelButton: true,
        cancelButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
        confirmButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        cancelButtonColor: "#F5222D",
        reverseButtons: true,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.confirmDoc()
        }
      })
    },
    async confirmDoc () {
      try {
        // console.log("doc", this.payload)
        let params = new URLSearchParams()
        params.append("doc_type", this.doc_code)
        this.payload.patient.patient_address = this.display_address
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/addTransaction?${params}`,
        // await this.axios.post(`http://localhost:5000/v1/addTransaction?${params}`,
        {
          payload: this.payload,
          doc_code: this.doc_code,
          doc_name: this.doc_name,
          biz_id: sessionStorage.biz_id,
          create_by: sessionStorage.role_name,
          patient_id:this.patient_id
        }).then((res) => {
          // console.log(res)
          this.$refs.form.resetValidation()
          this.dialog_open = false
          if (res.data.result === 'success') {
            this.$swal.fire({
              icon: "success",
              title: `<span style="font-size: 20px;">ขอเอกสารสำเร็จ</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
            EventBus.$emit('getData')
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async getStaff () {
      try {
        let params = new URLSearchParams()
        params.append("biz_id", sessionStorage.biz_id)
        params.append("mode", "all-doctor")
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`).then((res) => {
          // console.log(">>> res", res, " ---------------")

          if (this.mode == "input") {
            if (sessionStorage.role_name == "แพทย์") {
              for (let i in res.data.data) {
                if (res.data.data[i].one_id == sessionStorage.oneId) {
                  this.select_doc = res.data.data[i];
                }
              }
            }
          } else if (this.mode == "approve") {
            for (let i in res.data.data) {
              if (res.data.data[i].one_id == this.payload.doctor.one_id) {
                this.select_doc = res.data.data[i];
              }
            }
            // this.select_doc = {
            //   biz_id: this.payload.doctor.biz_id,
            //   doctor_license: this.payload.doctor.doctor_license,
            //   name_th:  this.payload.doctor.doctor_name,
            //   one_id: this.payload.doctor.one_id
            // }
          }

          this.searchDoc = res.data.data
        })
      } catch (err) {
        console.log(err)
      }
    },
    searchDoctor () {
      if (this.select_doc) {
        this.payload.doctor = {
          biz_id: this.select_doc.biz_id,
          doctor_license: this.select_doc.doctor_license,
          doctor_name: this.select_doc.name_th,
          one_id: this.select_doc.one_id
        }
      }
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
  }
}
</script>

<style scoped>
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot > .v-select__slot > input {
  line-height: 1.7rem;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  line-height: 1.7rem;
}

::v-deep .disable-txt > .v-input__control > .v-input__slot {
  background-color: rgb(232, 233, 233);
}
</style>
